import io from 'socket.io-client';
import config from './config.json';

const ioc =  io(config.server);

export default class ConnectionManager {
    
    static getIoc()
    {
        return ioc;
    }
}


// WEBPACK FOOTER //
// ./src/connection-manager.js